"use client";

import { useEffect, useMemo, useState } from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

function stripHtml(html) {
  if (!html) return "";
  return html.replace(/<[^>]*>?/gm, "");
}

function CorporateOffersTab({
  activeTab,
  onOfferBookNow,
  brandPageColor,
  onPackageBookNow,
}) {
  const [loading, setLoading] = useState(true);
  const [allOffers, setAllOffers] = useState([]);
  const [modalContent, setModalContent] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openOfferId, setOpenOfferId] = useState(null); // NEW: track expanded offer

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const fetchOffers = async () => {
      try {
        setLoading(true);

        const res = await fetch(
          `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/offers/GetCorporateOffers`,
          {
            signal: controller.signal,
          },
        );

        const json = await res.json();

        const offers =
          json?.errorCode === "0" && Array.isArray(json?.data) ? json.data : [];

        if (!isMounted) return;

        setAllOffers(offers);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Error fetching offers:", error);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchOffers();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const filteredOffers = useMemo(() => {
    return allOffers.filter((item) => {
      const type = item?.offerType?.toLowerCase();

      return activeTab === "offers" ? type === "offer" : type === "package";
    });
  }, [allOffers, activeTab]);

  const handleKnowMore = (offer) => {
    setModalContent({
      title: offer?.offerTitle || offer?.offerName,
      description:
        offer?.internalDescription ||
        offer?.offerDesc ||
        "No detailed description available.",
    });

    setIsModalOpen(true);
  };

  const handleToggleHotels = (offerId) => {
    setOpenOfferId((prev) => (prev === offerId ? null : offerId));
  };

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <h6 className="mb-0">Loading Offers...</h6>
      </Container>
    );
  }

  return (
    <Container>
      <div className="global-heading-sec text-left">
        <div className="alt-two">
          <h1 className="text-black text-center fw-semibold text-uppercase custom-hotel-header mt-4 mb-1">
            {activeTab === "offers" ? "Offers" : "Packages"}
          </h1>

          <div
            className="w-10 h-1 bg-orange-500 mx-auto mt-2 mb-4"
            style={{
              background: brandPageColor || "#f04e02",
            }}
          />
        </div>
      </div>

      {filteredOffers?.length > 0 ? (
        <div className="row g-4">
          {filteredOffers?.map((offer, index) => (
            <div
              className="col-12 col-md-6 col-lg-4"
              key={`${offer?.offerId || index}`}
            >
              <div className="card border-0 shadow-sm h-100 overflow-hidden">
                <div className="position-relative">
                  {/* <Image
                    src={
                      offer?.propertyData?.[0]?.images?.[0]?.propertyImage ||
                      offer?.propertyData?.[0]?.images?.[0]?.propertyImage ||
                      "/images/placeholder.png"
                    }
                    alt={offer?.propertyData?.[0]?.propertyName || "Offer"}
                    width={500}
                    height={280}
                    className="w-100"
                    style={{
                      objectFit: "cover",
                      height: "220px",
                    }}
                  /> */}

                  <div
                    className="position-absolute bottom-0 start-0 px-3 py-2 text-white fw-semibold"
                    style={{
                      background:
                        "linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,0.8))",
                      width: "100%",
                    }}
                  >
                    {offer?.property?.propertyName}
                  </div>
                </div>

                <div className="card-body d-flex flex-column px-3 offer-card-bodyy">
                  <h6 className="fw-semibold mb-2">{offer?.offerName}</h6>

                  <p className="text-muted mb-3">
                    {offer?.offerDesc?.length > 80
                      ? `${stripHtml(offer.offerDesc.slice(0, 80))}...`
                      : stripHtml(offer?.offerDesc || offer?.offerTitle)}
                  </p>

                  <div className="mt-auto d-flex gap-2 flex-wrap">
                    <button
                      type="button"
                      className="btn btn-outline-dark"
                      onClick={() => handleKnowMore(offer)}
                      style={{
                        fontSize: "10px",
                        borderRadius: "0px",
                      }}
                    >
                      Know More
                    </button>

                    <button
                      type="button"
                      className="btn text-white"
                      style={{
                        fontSize: "10px",
                        background: brandPageColor || "#f04e02",
                        borderRadius: "0px",
                      }}
                      onClick={() => handleToggleHotels(offer.propertyOfferId)}
                    >
                      Book Now
                    </button>
                    {openOfferId === offer.propertyOfferId && (
                      <div className="offers-hotel-hotel-list mt-3">
                        {offer?.propertyData?.length > 0 ? (
                          <ul className="list-unstyled mb-0">
                            {offer?.propertyData?.map((hotel) => (
                              <li key={hotel.propertyId} className="">
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    onPackageBookNow({
                                      property: hotel,
                                      propertyOfferId:
                                        offer?.propertyOfferId || 0,
                                    });
                                    setOpenOfferId(null);
                                  }}
                                >
                                  {/* {hotel.propertyName}, {hotel.cityName} */}

                                  <small>
                                    {hotel.propertyName}, {hotel.cityName}
                                  </small>
                                </button>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p>No hotels available for this offer.</p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center text-muted py-5 fw-semibold">
          No {activeTab === "offers" ? "offers" : "packages"} available
        </div>
      )}

      {isModalOpen && (
        <div
          className="modal fade show new-type-popup offer-more-modal"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h6 className="mt-3">{modalContent.title}</h6>

                <button
                  type="button"
                  className="btn-close modal-close-btn-in-body"
                  onClick={() => setIsModalOpen(false)}
                  style={{
                    backgroundColor: brandPageColor || "#f04e02",
                  }}
                >
                  x
                </button>

                <p
                  className="p-0 mt-3 html-content"
                  dangerouslySetInnerHTML={{
                    __html: modalContent.description || "",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Container>
  );
}

export default function HomeOffersTabs({
  activeTab,
  onTabChange,
  onOfferBookNow,
  onPackageBookNow,
  brandPageColor,
}) {
  return (
    <section className="home-offers-tabs py-4">
      <Container>
        <div className="d-flex justify-content-center mb-4">
          <div className="home-tab-switch">
            <button
              type="button"
              className={`home-tab-btn ${
                activeTab === "offers" ? "active" : ""
              }`}
              onClick={() => onTabChange("offers")}
            >
              Offers
            </button>

            <button
              type="button"
              className={`home-tab-btn ${
                activeTab === "packages" ? "active" : ""
              }`}
              onClick={() => onTabChange("packages")}
            >
              Packages
            </button>
          </div>
        </div>

        <CorporateOffersTab
          activeTab={activeTab}
          onOfferBookNow={onOfferBookNow}
          onPackageBookNow={onPackageBookNow}
          brandPageColor={brandPageColor}
        />
      </Container>
    </section>
  );
}
